import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
  pagingRevenueExpenditure,
  getRevenueExpenditureById,
  saveRevenueExpenditure,
  deleteRevenueExpenditure,
} from "app/services/RevenueExpenditureService";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { RECEIVER_TYPE } from "app/common/LocalConst";

export default class RevenueExpenditureStore {
  searchRevenueExpenditure = new SearchObject();
  pageRevenueExpenditure = null;
  selectedRevenueExpenditure = { entryType: RECEIVER_TYPE };
  openFormCreateOrEdit = false;
  openConfirmDeleteRevenueExpenditure = false;

  constructor() {
    makeAutoObservable(this);
  }

  pagingRevenueExpenditure = () => {
    pagingRevenueExpenditure(this.searchRevenueExpenditure).then(({ data }) => {
      this.pageRevenueExpenditure = data;
    });
  };

  handleChangeFormSearch = (searchRevenueExpenditure) => {
    this.searchRevenueExpenditure = checkSearchObject(
      this.searchRevenueExpenditure,
      searchRevenueExpenditure
    );
    this.pagingRevenueExpenditure();
  };

  handleOpenFormCreateOrEdit = (conceptAttributeTypeId, type) => {
    if (Boolean(conceptAttributeTypeId)) {
      getRevenueExpenditureById(conceptAttributeTypeId).then(({ data }) => {
        this.selectedRevenueExpenditure = data;
        this.openFormCreateOrEdit = true;
      });
    } else {
      this.selectedRevenueExpenditure = { entryType: type };
      this.openFormCreateOrEdit = true;
    }
  };

  saveRevenueExpenditure = (conceptAttributeType, { setSubmitting }) => {
    return saveRevenueExpenditure(conceptAttributeType)
      .then(({ data }) => {
        this.selectedRevenueExpenditure = null;
        toast.success("Lưu thành công!");
        this.handleClosePopup();
        this.pagingRevenueExpenditure();
        return data;
      })
      .finally(() => setSubmitting(false));
  };

  handleDeleteRevenueExpenditure = (conceptAttributeType) => {
    this.selectedRevenueExpenditure = { id: conceptAttributeType?.id };
    this.openConfirmDeleteRevenueExpenditure = true;
  };

  handleConfirmDeleteRevenueExpenditure = async () => {
    return await deleteRevenueExpenditure(this.selectedRevenueExpenditure.id)
      .then(() => {
        if (
          this.searchRevenueExpenditure.pageIndex > 1 &&
          this.pageRevenueExpenditure.content.length === 1
        ) {
          this.searchRevenueExpenditure.pageIndex -= 1;
        }
        toast.success("Xóa loại thuộc tính thành công!");
        this.handleClosePopup();
        this.pagingRevenueExpenditure();
      })
      .catch(function (error) {
        console.error(error);
        toast.error("Xóa loại thuộc tính thất bại!");
      });
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteRevenueExpenditure = false;
  };

  resetStore = () => {
    this.searchRevenueExpenditure = new SearchObject();
    this.pageRevenueExpenditure = null;
    this.selectedRevenueExpenditure = { entryType: RECEIVER_TYPE };
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteRevenueExpenditure = false;
  };
}
